export class UIConfigSessionObject{
  SSOResourceWidth: string;
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/UIConfigSessionObject.ts